export default __webpack_public_path__ + "static/media/certificate.6a1674be.svg";